<template>
  <Teleport to="body">
    <HModal v-if="activeModal" v-model="isModalOpen" :key-handlers="keyHandlers">
      <template #default="{ dialogProps }">
        <div class="modal-wrap mact" v-bind="dialogProps">
          <component
            :is="activeModal?.component"
            v-bind="activeModal?.props"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            aria-describedby="modal-desc"
            @close="handleClose"
            @cancel="handleCancel"
          />
        </div>
      </template>
    </HModal>
  </Teleport>
</template>

<script setup>
import { useModalsStore } from '@/store/modals.store'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { HModal } from '@cnd_fe/ui'

const modalsStore = useModalsStore()
const { activeModal } = storeToRefs(modalsStore)

const isModalOpen = computed({
  get: () => !!activeModal.value,
  set: (value) => {
    if (!value) {
      // payload 없이 close하지 말 것 - handleClose에서 호출
      return
    }
  }
})

const keyHandlers = computed(() => {
  if (activeModal.value?.props?.disableKeyClose) {
    return {}
  }

  return {
    onEnter: () => {
      if (activeModal.value) {
        modalsStore.close()
      }
    }
  }
})

const handleClose = (payload) => {
  if (payload !== undefined) {
    modalsStore.close(payload)
  } else {
    modalsStore.close()
  }
}

const handleCancel = (reason) => {
  modalsStore.cancel(reason)
}
</script>
